import { Palette } from 'core/config';
import styled from 'styled-components';

export const ExpandButton = styled.button`
    padding: 0.5rem;
    border: none;
    background-color: ${Palette.ORANGE};
    color: ${Palette.WHITE};
    border-radius: 8px;
    height: 35px;
    width: 35px;
    box-sizing: border-box;
    cursor: pointer;
    margin-left: auto;
`;

export const AddIcon = styled.span<{rotated?: boolean}>`
    font-size: 25px;
    font-weight: bold;
    transform: translateY(-5px) ${({ rotated }) => rotated && 'rotate(45deg)'};
    display: block;
`;

export const TrashIcon = styled.img<{ uploading: boolean }>`
    height: 35px;
    width: 35px;
    cursor: pointer;
    ${({ uploading }) => uploading && 'opacity: 0.5;'}
`;
